import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useJournalStore } from '../hooks/useJournalStore';
import { DashboardShell } from '../layouts/DashboardShell';

export function JournalDashboard() {
  const { rootId } = useParams<{ rootId: string }>();
  const { loadJournal, startStream, stopStream } = useJournalStore();

  useEffect(() => {
    if (!rootId) return;
    loadJournal(rootId);
    startStream(rootId);
    return () => stopStream();
  }, [rootId]);

  return <DashboardShell journalRootId={rootId} />;
}
